import React, { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Col, Row, Table } from "components/bootstrap";
import PaginatedList from "components/common/PaginatedList";
import SearchForm from "components/common/SearchForm";
import Spinner from "components/common/Spinner";
import useUserSearchFiltersQuery from "search-filter/hooks/useUserSearchFiltersQuery";
import QueryHelper from "components/common/QueryHelper";
import { FILTER_SCOPES } from "search-filter/constants";
import usePaginationQueryParameter from "hooks/usePaginationQueryParameter";
import usePluggableEntityTableElements from "hooks/usePluggableEntityTableElements";
import { NoEntitiesExist } from "components/common";
import FiltersOverviewItem from "./FiltersOverviewItem";
const ListHeader = ({ pluggableTableHeaders }) => {
  const { t } = useTranslation("enterprise_search");
  return /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, t("filters_overview.title")), /* @__PURE__ */ React.createElement("th", null, t("filters_overview.query_string")), /* @__PURE__ */ React.createElement("th", null, t("filters_overview.description")), pluggableTableHeaders, /* @__PURE__ */ React.createElement("th", { className: "text-right" }, t("filters_overview.actions"))));
};
const FiltersOverview = () => {
  var _a;
  const { page, pageSize, resetPage } = usePaginationQueryParameter();
  const [filterQuery, setSearchFilter] = useState("");
  const { pluggableTableHeaders } = usePluggableEntityTableElements(
    null,
    "search_filter"
  );
  const { t } = useTranslation("enterprise_search");
  const {
    data: { filters = [], pagination },
    isFetching
  } = useUserSearchFiltersQuery({ query: filterQuery, page, per_page: pageSize, scope: FILTER_SCOPES.ALL });
  const handleSearch = useCallback(
    (newSearchQuery) => {
      setSearchFilter(newSearchQuery);
      resetPage();
    },
    [resetPage, setSearchFilter]
  );
  const handleReset = useCallback(() => {
    handleSearch(void 0);
  }, [handleSearch]);
  return /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { xs: 12 }, /* @__PURE__ */ React.createElement(PaginatedList, { totalItems: (_a = pagination == null ? void 0 : pagination.total) != null ? _a : 0 }, /* @__PURE__ */ React.createElement(
    SearchForm,
    {
      onSearch: handleSearch,
      onReset: handleReset,
      topMargin: 0,
      queryHelpComponent: /* @__PURE__ */ React.createElement(
        QueryHelper,
        {
          entityName: "filter",
          commonFields: ["id", "title", "description"],
          fieldMap: { queryString: t("filters_overview.query_string_help") }
        }
      )
    }
  ), /* @__PURE__ */ React.createElement(Table, { condensed: true }, /* @__PURE__ */ React.createElement(ListHeader, { pluggableTableHeaders }), /* @__PURE__ */ React.createElement("tbody", null, isFetching && /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { colSpan: 4, "aria-label": t("filters_overview.loading_filters") }, /* @__PURE__ */ React.createElement(Spinner, { delay: 0 }))), filters.length < 1 ? /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { colSpan: 4, "aria-label": t("filters_overview.no_filter_found_label") }, /* @__PURE__ */ React.createElement(NoEntitiesExist, null, t("filters_overview.no_filter_found")))) : /* @__PURE__ */ React.createElement(React.Fragment, null, filters.map((filter) => /* @__PURE__ */ React.createElement(FiltersOverviewItem, { key: filter.id, filter }))))))));
};
export default FiltersOverview;
